module.exports = __webpack_public_path__ + "img/banner.124dc0d.png";